// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// The header steps out of the way while the page is read downwards and slides
// back as soon as the reader scrolls up. It moves by transform, so the
// transparent overlay header on home and campaign pages keeps its sticky
// footprint and nothing below it shifts.
(() => {
  const header = document.querySelector('.section-header');
  if (!header) return;

  const AWAY = 'sp-header-away';
  const DOWN = 6;
  const UP = 4;
  let height = header.offsetHeight || 72;
  let lastY = Math.max(0, window.scrollY);
  let ticking = false;

  const measure = () => {
    height = header.offsetHeight || height;
  };

  // A header that carries an open menu, an open search or a focused control
  // must stay put, otherwise it would drag its own overlay off screen.
  const pinned = () =>
    [...document.body.classList].some((name) => name.startsWith('overflow-hidden')) ||
    header.querySelector('details[open]') !== null ||
    header.contains(document.activeElement) ||
    document.querySelector('cart-drawer.active, .drawer.active, quick-add-modal[open]') !== null;

  const show = () => header.classList.remove(AWAY);

  const update = () => {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    if (pinned() || y <= height + 40) {
      show();
      lastY = y;
      return;
    }
    const delta = y - lastY;
    if (delta > DOWN) {
      header.classList.add(AWAY);
      lastY = y;
    } else if (delta < -UP) {
      show();
      lastY = y;
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    measure();
    update();
  }, { passive: true });
  window.addEventListener('pageshow', () => {
    measure();
    lastY = Math.max(0, window.scrollY);
    show();
  });
  header.addEventListener('focusin', show);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') show();
  });

  measure();
  update();
})();
